import GiftTripHero from "../components/gifttrip/GiftTripHero";
import WhyGiftTrip from "../components/gifttrip/WhyGiftTrip";
import GiftTripForm from "../components/gifttrip/GiftTripForm";

function GiftTrip() {
  return (
    <>
      <GiftTripHero />
       <WhyGiftTrip />
      <GiftTripForm />
    </>
  );
}

export default GiftTrip;